module.exports = __webpack_public_path__ + "static/primary-black-68232d632804e026bf10841c9091759b.png";